import {Component} from '@angular/core';
import {RoutesEnum} from './core/services/navigation/routes.enum';
import {NavigationService} from './core/services/navigation/navigation.service';

@Component({
  selector: 'xp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor(
    private readonly _navigationService: NavigationService,
  ) {
  }

  public get showToolBar(): boolean {
    const excludedPages: Array<RoutesEnum | null> = [RoutesEnum.AUTHENTICATION, RoutesEnum.CLINICAL_REPORT];
    return !excludedPages.includes(this._navigationService.currentPage);
  }

}
